import { CreateGuestComponent } from "./create-guest/create-guest.component";
import { EditGuestComponent } from "./edit-guest/edit-guest.component";
import { GuestListComponent } from "./guest-list/guest-list.component";
import { GuestViewComponent } from "./guest-view/guest-view.component";
import { GuestComponent } from "./guest.component";


export const GuestDeclatation = [
    GuestComponent,
    CreateGuestComponent,
    EditGuestComponent,
    GuestListComponent,
    GuestViewComponent
];
